if (!customElements.get('media-gallery')) {

  class MediaGallery extends HTMLElement {

    constructor() {

      super();

      if (Shopify.designMode) {

        setTimeout(() => this.init(), 200);

      } else {

        this.init();

      }

    }

    disconnectedCallback() {

      window.removeEventListener('on:debounced-resize', this.resizeHandler);

      if (this.resizeInitHandler) {

        window.removeEventListener('on:debounced-resize', this.resizeInitHandler);

      }

      if (this.zoomInitHandler) {

        window.removeEventListener('on:debounced-resize', this.zoomInitHandler);

      }

    }

    init() {

      this.section = this.closest('.js-product');

      this.mediaGroupingEnabled = this.hasAttribute('data-media-grouping-enabled')

        && this.getMediaGroupData();

      this.stackedScroll = this.dataset.stackedScroll;

      this.stackedUnderline = this.dataset.stackedUnderline === 'true' && !this.mediaGroupingEnabled;

      this.isFeatured = this.dataset.isFeatured === 'true';

      this.viewer = this.querySelector('.media-viewer');

      this.thumbs = this.querySelector('.media-thumbs');

      this.thumbsItems = this.querySelectorAll('.media-thumbs__item');

      this.controls = this.querySelector('.media-ctrl');

      this.prevBtn = this.querySelector('.media-ctrl__btn[name="prev"]');

      this.nextBtn = this.querySelector('.media-ctrl__btn[name="next"]');

      this.counterCurrent = this.querySelector('.media-ctrl__current-item');

      this.counterTotal = this.querySelector('.media-ctrl__total-items');

      this.liveRegion = this.querySelector('.media-gallery__status');

      this.zoomLinks = this.querySelectorAll('.js-zoom-link');

      this.loadingSpinner = this.querySelector('.loading-spinner');

      this.xrButton = this.querySelector('.media-xr-button');

      if (this.hasAttribute('data-zoom-enabled')) {

        this.galleryModal = this.querySelector('.js-media-zoom-template').content.firstElementChild.cloneNode(true);

      }

      if (this.mediaGroupingEnabled) {

        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());

      }

if (this.mediaGroupingEnabled) {

  let grp = this.getMediaGroupFromOptionSelectors()

    || this.getAttribute('data-current-variant-id')

    || new URLSearchParams(location.search).get('variant');

  if (grp) this.setActiveMediaGroup(String(grp));

}

      if (this.dataset.layout === 'stacked' && theme.mediaMatches.md) {

        this.resizeInitHandler = this.resizeInitHandler || this.initGallery.bind(this);

        window.addEventListener('on:debounced-resize', this.resizeInitHandler);

        this.setVisibleItems();

        this.previousMediaItem = this.querySelector('.media-viewer__item.is-current-variant');

        setTimeout(() => this.customSetActiveMedia(this.previousMediaItem, this.stackedScroll === 'always'), 200);

      } else {

        this.initGallery();

      }

      if (this.zoomLinks) {

        if (this.dataset.zoomTrigger === 'hover') {

          this.triggerZoomInit();

        } else {

          this.zoomLinks.forEach((zoomLink) => {

            zoomLink.addEventListener('click', (evt) => {

              this.triggerZoomInit();

              evt.preventDefault();

            });

          });

        }

      }

      this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));

    }

    triggerZoomInit() {

      this.zoomInitHandler = this.zoomInitHandler || this.initZoom.bind(this);

      this.zoomEventListener = this.zoomEventListener || this.handleZoomMouseMove.bind(this);

      window.addEventListener('on:debounced-resize', this.zoomInitHandler);

      this.initZoom();

      this.zoomLinks.forEach((zoomLink) => {

        zoomLink.addEventListener('click', (evt) => {

          evt.preventDefault();

        });

      });

    }

    /**

     * Handle a change in variant on the page.

     * @param {Event} evt - variant change event dispatched by variant-picker

     */

  onVariantChange(evt) {

  if (this.mediaGroupingEnabled) {

    const v = evt.detail.variant;

    const grp = v ? String(v.id) : this.getMediaGroupFromOptionSelectors();

    this.setActiveMediaGroup(grp);

  }

      if (evt.detail.variant && evt.detail.variant.featured_media) {

        const variantMedia = this.viewer.querySelector(

          `[data-media-id="${evt.detail.variant.featured_media.id}"]`

        );

        this.customSetActiveMedia(variantMedia, true);

      }

      this.setVisibleItems();
      if (!this.visibleItems.includes(this.currentItem) && this.visibleItems.length > 0) {
        this.customSetActiveMedia(this.visibleItems[0], true);
      }
    }

    /**

     * Gets the media group from currently selected variant options.

     * @returns {?object}

     */

getMediaGroupFromOptionSelectors() {

  const data = this.getMediaGroupData();

  if (data && data.groupBy === 'variant') {

    // a) Formular (kann in anderem Abschnitt sein)

    let idInput =

      this.section.querySelector('form [name="id"]') ||

      document.querySelector('form[action*="/cart/add"] [name="id"]') ||

      document.querySelector('form [name="id"]');

    if (idInput && idInput.value) return String(idInput.value);

    // b) Data-Attribut am <media-gallery>

    const fromAttr = this.getAttribute('data-current-variant-id');

    if (fromAttr) return String(fromAttr);

    // c) URL: ?variant=...

    const vid = new URLSearchParams(location.search).get('variant');

    if (vid) return String(vid);

  }

  // Fallback: alte Option-Logik (nur relevant, wenn groupBy != 'variant')

  const optionSelectors = this.section.querySelectorAll('.option-selector');

  if (optionSelectors.length > (this.getMediaGroupData().groupOptionIndex || 0)) {

    const selector = optionSelectors[this.getMediaGroupData().groupOptionIndex || 0];

    if (selector.dataset.selectorType === 'dropdown') {

      const btn = selector.querySelector('.custom-select__btn');

      return btn ? btn.textContent.trim() : null;

    }

    const checked = selector.querySelector('input:checked');

    return checked ? checked.value : null;

  }

  return null;

}

    /**

     * Gets the variant media associations for a product.

     * @returns {?object}

     */

    getMediaGroupData() {

      if (typeof this.variantMediaData === 'undefined') {

        const dataEl = this.querySelector('.js-data-variant-media');

        this.variantMediaData = dataEl ? JSON.parse(dataEl.textContent) : false;

      }

      return this.variantMediaData;

    }

    /**

     * Gets an object mapping media to groups, and the reverse

     * @returns {?object}

     */

   getMediaGroupMap() {

  if (!this.mediaGroupMap) {

    const data = this.getMediaGroupData();

    this.mediaGroupMap = { groups: {} };

    // 1) Schnelle Lookup-Map: mediaId -> option (Variant-ID)

    const idToGroup = new Map();

    (data?.variantMedia || []).forEach(entry => {

      idToGroup.set(String(entry.mediaId), String(entry.option));

    });

    // 2) Alle DOM-Items durchgehen und zur richtigen Gruppe legen

    this.viewerItems = this.querySelectorAll('.media-viewer__item');

    this.viewerItems.forEach(item => {

      const mediaId = String(item.dataset.mediaId);

      const groupName = idToGroup.get(mediaId); // z.B. "53307156…"

      if (!groupName) return; // kein Mapping → Item gehört zu keiner Gruppe (wird ausgeblendet)

      if (!this.mediaGroupMap.groups[groupName]) {

        this.mediaGroupMap.groups[groupName] = { name: groupName, items: [] };

      }

      const groupItem = { main: item };

      if (this.thumbs) {

        groupItem.thumb = this.thumbs.querySelector(

          `[data-media-id="${item.dataset.mediaId}"].media-thumbs__item`

        );

      }

      this.mediaGroupMap.groups[groupName].items.push(groupItem);

    });

    // 3) Helper

    this.mediaGroupMap.groupFromItem = (item) => {

      const groups = Object.keys(this.mediaGroupMap.groups);

      for (let i = 0; i < groups.length; i += 1) { // (fix: .length)

        const g = this.mediaGroupMap.groups[groups[i]];

        for (let j = 0; j < g.items.length; j += 1) {

          if (g.items[j].main === item) return g;

        }

      }

      // Fallback: erste Gruppe

      return this.mediaGroupMap.groups[Object.keys(this.mediaGroupMap.groups)[0]];

    };

  }

  return this.mediaGroupMap;

}

    /**

     * Show only images associated to the current variant

     * @param {string} groupName - optional - Group to show (uses this.currentItem if empty)

     */

    setActiveMediaGroup(groupName) {

      const mediaGroupMap = this.getMediaGroupMap();

      const selectedGroup = groupName

        ? mediaGroupMap.groups[groupName]

        : mediaGroupMap.groupFromItem(this.currentItem);

      if (selectedGroup) {

        if (this.currentGroup !== selectedGroup) {

          this.currentGroup = selectedGroup;

          this.viewerItems.forEach((item) => {

            item.style.display = 'none';

            item.classList.remove('media-viewer__item--single');

          });

          this.thumbsItems.forEach((item) => {

            item.style.display = 'none';

          });

          let currentItemIsVisible = false;

          selectedGroup.items.forEach((item) => {

            item.main.style.display = '';

            if (item.thumb) {

              item.thumb.style.display = '';

            }

            if (item.main === this.currentItem) {

              currentItemIsVisible = true;

            }

          });

          this.setVisibleItems();

          // If current item is not in this group, set it as the active item

          if (!currentItemIsVisible) {

            this.customSetActiveMedia(selectedGroup.items[0].main, true);

          }

          // Handle single images on stacked view

          if (selectedGroup.items.length === 1) {

            selectedGroup.items[0].main.classList.add('media-viewer__item--single');

          }

        }

      } else {

        this.viewerItems.forEach((item) => {

          item.style.display = '';

        });

        this.thumbsItems.forEach((item) => {

          item.style.display = '';

        });
        this.currentGroup = null;

      }
      this.setVisibleItems();
      if (!this.visibleItems.includes(this.currentItem) && this.visibleItems.length > 0) {
        this.customSetActiveMedia(this.visibleItems[0], true);
      }

    }

    /**

     * Initialises the media gallery slider and associated controls.

     */

    initGallery() {

      this.setVisibleItems();
      this.addListeners();
      if (this.visibleItems.length === 0) return;
      if (!this.visibleItems.includes(this.currentItem)) {
        this.currentItem = this.getNearestVisibleItem();
      }
      this.updateMediaControls();

      if (this.thumbs && this.currentItem) {

        this.currentThumb = this.thumbs.querySelector(

          `[data-media-id="${this.currentItem.dataset.mediaId}"]`

        );

      }

      if (!this.isFeatured && document.hasFocus()) {

        // Eager load the slider images for smooth UX

        this.viewer.querySelectorAll('.product-image[loading="lazy"]').forEach((img, index) => {

          setTimeout(() => {

            img.loading = 'eager';

          }, 500 * (index + 1));

        });

      }

      const featuredItem = this.viewer.querySelector('.media-viewer__item.is-current-variant');
      const currentItem = this.visibleItems.includes(featuredItem)
        ? featuredItem : this.currentItem;
      this.customSetActiveMedia(currentItem, true);

    }

    addListeners() {
      if (this.galleryListenersAdded) return;
      this.galleryListenersAdded = true;

      this.viewer.addEventListener('scroll', this.handleScroll.bind(this));

      if (this.controls) this.controls.addEventListener('click', this.handleNavClick.bind(this));

      if (this.thumbs) this.thumbs.addEventListener('click', this.handleThumbClick.bind(this));

      this.resizeHandler = this.resizeHandler || this.handleResize.bind(this);

      window.addEventListener('on:debounced-resize', this.resizeHandler);

    }

    /**

     * Initialized the zoom on hover for desktop

     */

    initZoom() {

      this.zoomLinks.forEach((el) => {

        const zoomWidth = Number(el.querySelector('.zoom-image').dataset.originalWidth || 0);

        const imageWidth = el.querySelector('.product-image').getBoundingClientRect().width;

        if (theme.mediaMatches.md && ((zoomWidth - 75) > (imageWidth))) {

          el.addEventListener('mousemove', this.zoomEventListener);

          el.classList.remove('pointer-events-none');

        } else {

          el.removeEventListener('mousemove', this.zoomEventListener);

          el.classList.add('pointer-events-none');

        }

      });

    }

    /**

     * Handles mouse move over a zoomable image

     * @param {?object} evt - Event object.

     */

    handleZoomMouseMove(evt) {

      if (this.hasAttribute('data-zoom-enabled') && !this.dataset.zoomTrigger && !evt.target.closest('.gallery-zoom-modal')) {

        return;

      }

      const hoverElem = evt.currentTarget;

      const zoomImage = hoverElem.querySelector('.js-zoom-image');

      // Download the zoom image if necessary

      if (zoomImage.dataset.src) {

        this.loadingSpinner.classList.remove('loading-spinner--out');

        const img = new Image();

        img.src = zoomImage.dataset.src;

        img.onload = () => {

          zoomImage.src = img.src;

          hoverElem.classList.remove('media--zoom-not-loaded');

          this.loadingSpinner.classList.add('loading-spinner--out');

        };

        zoomImage.removeAttribute('data-src');

      }

      try {

        const offsetX = evt.offsetX ? evt.offsetX : evt.touches[0].pageX;

        const offsetY = evt.offsetY ? evt.offsetY : evt.touches[0].pageY;

        const x = (offsetX / zoomImage.offsetWidth) * 100;

        const y = (offsetY / zoomImage.offsetHeight) * 100;

        zoomImage.style.objectPosition = `${x}% ${y}%`;

      } catch (err) {

        // Fail silently

      }

    }

    /**

     * Handles 'scroll' events on the main media container.

     */

    handleScroll() {
      if (!this.visibleItems || this.visibleItems.length <= 1) {
        this.updateMediaControls();
        return;
      }
      const item = this.getNearestVisibleItem();
      if (item && item !== this.currentItem) this.customSetActiveMedia(item, false);
    }

    /**

     * Handles 'click' events on the controls container.

     * @param {object} evt - Event object.

     */

    handleNavClick(evt) {
      const button = evt.target.closest('.media-ctrl__btn');
      if (!button || button.disabled || !this.controls.contains(button)) return;
      this.setVisibleItems();
      const itemToShow = button === this.nextBtn
        ? this.visibleItems[this.currentIndex + 1]
        : this.visibleItems[this.currentIndex - 1];
      if (!itemToShow) return;
      this.viewer.scrollTo({ left: itemToShow.offsetLeft, behavior: 'smooth' });
    }

    /**

     * Handles 'click' events on the thumbnails container.

     * @param {object} evt - Event object.

     */

    handleThumbClick(evt) {

      const thumb = evt.target.closest('[data-media-id]');

      if (!thumb) return;

      const itemToShow = this.querySelector(`[data-media-id="${thumb.dataset.mediaId}"]`);

      this.customSetActiveMedia(itemToShow);

      MediaGallery.playActiveMedia(itemToShow);

    }

    /**

     * Handles debounced 'resize' events on the window.

     */

    handleResize() {
      this.setVisibleItems();
      const item = this.visibleItems.includes(this.currentItem)
        ? this.currentItem : this.visibleItems[0];
      if (item) this.customSetActiveMedia(item, true);
      if (this.thumbs && this.currentThumb) this.checkThumbVisibilty(this.currentThumb);
    }

    /**

     * Stub for variant-picker calls. Listening to change event instead.

     */

    // eslint-disable-next-line class-methods-use-this

    setActiveMedia() {}

    /**

     * Sets the active media item.

     * @param {Element} mediaItem - Media element to set as active.

     * @param {boolean} [scrollToItem=true] - Scroll to the active media item.

     */

   customSetActiveMedia(mediaItem, scrollToItem = true) {

      if (!this.visibleItems) this.setVisibleItems();
      if (!mediaItem || !this.visibleItems.includes(mediaItem)) {
        mediaItem = this.visibleItems[0];
      }
      if (!mediaItem) {
        this.currentItem = null;
        this.updateMediaControls();
        return;
      }
      if (mediaItem === this.currentItem) {
        this.updateMediaControls();
        if (scrollToItem && !(this.dataset.layout === 'stacked' && theme.mediaMatches.md)) {
          this.viewer.scrollTo({ left: mediaItem.offsetLeft });
        }
        return;
      }

      window.pauseAllMedia(this);

      this.currentItem = mediaItem;

      this.currentIndex = this.visibleItems.indexOf(this.currentItem);
      this.updateMediaControls();

      if (this.dataset.layout === 'stacked' && theme.mediaMatches.md) {

        // Update the active class and scroll to the active media

        if (this.stackedUnderline) {

          if (this.previousMediaItem) this.previousMediaItem.classList.remove('is-active');

          mediaItem.classList.add('is-active');

          this.previousMediaItem = mediaItem;

        }

        if (this.stackedScroll !== 'never') {

          const y = mediaItem.getBoundingClientRect().top

            + document.documentElement.scrollTop - 150;

          // If the element is far enough away to scroll to it

          if (Math.abs(y - document.documentElement.scrollTop) > 300) {

            window.scrollTo({

              top: y < 100 ? 0 : y,

              behavior: 'smooth'

            });

          }

        }

        return;

      }

      if (scrollToItem) this.viewer.scrollTo({ left: this.currentItem.offsetLeft });

      if (this.thumbs) this.setActiveThumb();

      this.announceLiveRegion(this.currentItem, this.currentIndex + 1);

      if (this.xrButton && mediaItem.dataset.mediaType === 'model') {

        this.xrButton.dataset.shopifyModel3dId = mediaItem.dataset.mediaId;

      }

    }

    /**

     * Sets the active thumbnail.

     */

    setActiveThumb() {

      this.currentThumb = this.thumbs.querySelector(

        `[data-media-id="${this.currentItem.dataset.mediaId}"]`

      );

      if (!this.currentThumb) return;
      const btn = this.currentThumb.querySelector('button');
      if (!btn) return;

      this.thumbs.querySelectorAll('.media-thumbs__btn').forEach((el) => {

        el.classList.remove('is-active');

        el.removeAttribute('aria-current');

      });

      btn.classList.add('is-active');

      btn.setAttribute('aria-current', 'true');

      this.checkThumbVisibilty(this.currentThumb);

    }

    /**

     * Creates an array of the visible media items.

     */

    setVisibleItems() {
      this.viewerItems = this.viewer.querySelectorAll('.media-viewer__item');
      this.visibleItems = Array.from(this.viewerItems).filter((el) => el.clientWidth > 0);
      this.viewerItemOffset = this.visibleItems.length > 1
        ? this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft
        : 0;
      this.updateMediaControls();
    }

    // Counter and arrows always use the same currently visible gallery items.
    updateMediaControls() {
      const items = this.visibleItems || [];
      const total = items.length;
      const activeIndex = items.indexOf(this.currentItem);
      this.currentIndex = total === 0 ? -1 : Math.max(0, activeIndex);

      if (this.counterTotal) this.counterTotal.textContent = String(total);
      if (this.counterCurrent) {
        this.counterCurrent.textContent = String(total === 0 ? 0 : this.currentIndex + 1);
      }
      if (this.prevBtn) this.prevBtn.disabled = total <= 1 || this.currentIndex <= 0;
      if (this.nextBtn) this.nextBtn.disabled = total <= 1 || this.currentIndex >= total - 1;
      if (this.controls) {
        this.controls.hidden = total <= 1;
        this.controls.style.display = total <= 1 ? 'none' : '';
      }
    }

    // Offsets are more reliable than dividing scrollLeft by a cached slide width.
    getNearestVisibleItem() {
      if (!this.visibleItems || this.visibleItems.length === 0) return null;
      const scrollLeft = this.viewer.scrollLeft;
      return this.visibleItems.reduce((nearest, item) => (
        Math.abs(item.offsetLeft - scrollLeft) < Math.abs(nearest.offsetLeft - scrollLeft)
          ? item : nearest
      ));
    }

    /**

     * Ensures a thumbnail is in the visible area of the slider.

     * @param {Element} thumb - Thumb item element.

     */

    checkThumbVisibilty(thumb) {

      const scrollPos = this.thumbs.scrollLeft;

      const lastVisibleThumbOffset = this.thumbs.clientWidth + scrollPos;

      const thumbOffset = thumb.offsetLeft;

      if (thumbOffset + thumb.clientWidth > lastVisibleThumbOffset || thumbOffset < scrollPos) {

        this.thumbs.scrollTo({ left: thumbOffset, behavior: 'smooth' });

      }

    }

    /**

     * Updates the media gallery status.

     * @param {Element} mediaItem - Active media element.

     * @param {number} index - Active media index.

     */

    announceLiveRegion(mediaItem, index) {

      const image = mediaItem.querySelector('.media-viewer img');

      if (!image) return;

      this.liveRegion.setAttribute('aria-hidden', 'false');

      this.liveRegion.innerHTML = theme.strings.imageAvailable.replace('[index]', index);

      setTimeout(() => {

        this.liveRegion.setAttribute('aria-hidden', 'true');

      }, 2000);

    }

    /**

     * Loads the deferred media for the active item.

     * @param {Element} mediaItem - Active media element.

     */

    static playActiveMedia(mediaItem) {

      window.pauseAllMedia();

      const deferredMedia = mediaItem.querySelector('deferred-media');

      if (deferredMedia) deferredMedia.loadContent();

    }

  }

  customElements.define('media-gallery', MediaGallery);

}
